import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Export notify object with success and error methods
export const notify = {
  success: (message) =>
    toast.success(message, {
      position: "top-right",
      autoClose: 3000,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
    }),

  error: (message) =>
    toast.error(message, {
      position: "top-right",
      autoClose: 3000,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
    }),
};
